/* globals angular */

var ngModule = angular.module('trends');

ngModule.directive('gridSystem', function () {
    return {
        restrict: 'A',
        scope: true,
        link: function (scope) {
            scope.grid = {};
            scope.grid.trend = [8, 4, 4, 8, 4, 4, 4, 6, 6];
            scope.grid.observation = [4, 8, 8, 4, 4, 4, 4, 6, 6];
            scope.grid.group = {'region': 6, 'demographic': 4, 'sector': 4, 'theme': 4};

            scope.getLayout = function(key, index) {
                var grid = scope.grid[key];
                if (grid !== null) {
                    return grid[index % grid.length];
                }
                return 12;
            };

            scope.getGroupLayout = function() {
                return scope.grid.group[scope.selectedTab];
            };
        }
    };
});
